import React from 'react';

const CommunityAIIcon = ({ size = 24, className = "" }) => {
  return (
    <div className={`community-ai-icon ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="robot-icon"
      >
        <rect x="3" y="11" width="18" height="10" rx="2" />
        <circle cx="12" cy="5" r="2" />
        <path d="M12 7v4" />
        <line x1="8" y1="16" x2="8" y2="16" />
        <line x1="16" y1="16" x2="16" y2="16" />
        <path d="M9 11v-4" />
        <path d="M15 11v-4" />
      </svg>
      <div className="ai-badge">AI</div>
    </div>
  );
};

export default CommunityAIIcon; 